<template>
  <div>
    <Breadtabsheader/>
    <div class="h-content">
      <!--查询-->
      <div class="h-piece">
        <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="统计年月">
              <el-date-picker v-model="q.statMonth" type="month" value-format="yyyyMM" placeholder="选择月" clearable style="width:100%"/>
            </el-form-item>
            <el-form-item label="物料编码/名称">
              <el-input v-model="q.materialCode" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="供应商编码/名称">
              <el-input v-model="q.supplierName" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="毛利率>=30%">
              <el-select v-model="q.flagOver30" placeholder="请选择" clearable style="width:100%">
                <el-option label="是" :value="1"/>
                <el-option label="否" :value="0"/>
              </el-select>
            </el-form-item>
          </div>
          <el-collapse-transition>
            <div v-show="isScreen">
              <div class="h-thirdColumn w-newColumn">
                <el-form-item label="链群">
                  <el-input v-model="q.chainGroup" placeholder="请输入" clearable/>
                </el-form-item>
              </div>
            </div>
          </el-collapse-transition>
        </el-form>
        <div class="l-screenBox">
          <div class="l-screen" @click="collapseChange">
            <img :src="isScreen?closeScreen:drawScreen" alt="">
            <div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
          </div>
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
            <el-button class="h-btn h-formBtn h-bggreen" @click="triggerCalc">计算毛利率</el-button>
          </div>
        </div>
      </div>
      <!--数据展示-->
      <div class="h-table h-mrt30">
        <el-table :data="tableData" ref="multipleTable" stripe border style="width: 100%" max-height="450">
          <el-table-column prop="statMonth" label="统计年月" width="90"/>
          <el-table-column prop="chainGroupName" label="物料大类" width="100" show-overflow-tooltip/>
          <el-table-column prop="materialCode" label="物料编码" width="100" show-overflow-tooltip/>
          <el-table-column prop="materialName" label="物料描述" min-width="150" show-overflow-tooltip/>
          <el-table-column prop="supplierCode" label="供应商编码" width="100"/>
          <el-table-column prop="supplierName" label="供应商名称" min-width="150" show-overflow-tooltip/>
          <el-table-column prop="purchasePrice" label="采购价" width="100"/>
          <el-table-column prop="pricing" label="销售价" width="100"/>
          <el-table-column prop="grossMarginRate" label="毛利率(%)" width="100">
            <template slot-scope="scope">{{ scope.row.grossMarginRate != null ? (scope.row.grossMarginRate * 100).toFixed(2) : '' }}</template>
          </el-table-column>
          <el-table-column prop="receiptQty" label="入库数量" width="100"/>
          <el-table-column prop="purchaseTotalAmount" label="采购总额" width="110"/>
          <el-table-column prop="purchaseReductionTotal" label="采购降价总额" width="120"/>
          <el-table-column prop="flagOver30" width="100">
            <template slot="header">
              <span>毛利率<br/>&gt;=30%</span>
            </template>
            <template slot-scope="scope">{{ scope.row.flagOver30 == 1 ? '是' : '否' }}</template>
          </el-table-column>
        </el-table>
        <div class="h-tableBL">
          <el-button class="h-btn h-formBtn h-bgblueQ" @click="exportExcel">批量导出</el-button>
        </div>
        <div class="h-pagination2">
          <pagination :page="q" @query="query"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import grossMargin from "@/api/invoice/grossMargin";
import updownfile from "@/utils/updownfile";

export default {
  data() {
    return {
      q: { statMonth: '', materialCode: '', supplierName: '', chainGroup: '', flagOver30: null, pageNo: 1, pageSize: 10, total: 0 },
      tableData: [],
      isScreen: false,
      closeScreen: require("@/assets/images/pimg/closeallic.png"),
      drawScreen: require("@/assets/images/pimg/dobleArr.png"),
    }
  },
  methods: {
    collapseChange() { this.isScreen = !this.isScreen; },
    handleFilter() { this.q.pageNo = 1; this.query(); },
    resetData() {
      this.q = { statMonth: '', materialCode: '', supplierName: '', chainGroup: '', flagOver30: null, pageNo: 1, pageSize: 10, total: 0 };
      this.query();
    },
    query() {
      grossMargin.selectPage(this.q).then(res => {
        this.tableData = res.records;
        this.q.total = res.total;
      });
    },
    triggerCalc() {
      const ym = this.q.statMonth || '';
      this.$confirm('确定要计算' + (ym || '当月') + '毛利率数据吗？', '提示', { type: 'warning' }).then(() => {
        grossMargin.triggerGrossMargin(ym).then(res => {
          if (res.f) { this.$message.success(res.msg || '计算完成'); this.query(); }
        });
      }).catch(() => {});
    },
    exportExcel() {
      let params = { ...this.q };
      updownfile.down(grossMargin.baseurl + '/downloadExcel', params, "get");
    },
  },
  created() { this.query(); },
  activated() { this.query(); },
}
</script>
<style lang="less" scoped>
</style>
